import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeTagBr',
    standalone: false
})
export class RemoveTagBrPipe implements PipeTransform {
	transform(value: string): string {
		let expression = value.replace(/<br [/]>/g, '');
		expression = expression.replace(/<br>/g, '');
		return expression;
	}
}
